import React, { useEffect, useState } from 'react';
import { useTable } from 'react-table';
import Select from 'react-select';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { enUS } from 'date-fns/locale';

const LoggingView = () => {
    registerLocale('en', enUS);
    const filters = [
        {value: 'TVG', label: 'TVG'},
        {value: 'Microsoft CRM', label: 'Microsoft CRM'},
        {value: 'INFO', label: 'INFO'},
        {value: 'WARNING', label: 'WARNING'},
        {value: 'ERROR', label: 'ERROR'}
    ];
    const [startDate, setStartDate] = useState(new Date());
    const [type, setType] = useState(filters[1]);

    useEffect(() => {
        getItems();
    }, [startDate, type]);

    const getItems = () => {
        console.log('call to api');
        console.log({startDate});
        console.log({type});
    };

    const data = React.useMemo(
        () => [
            {
                stamp: '4 Jul 2021, 00:15:32',
                topic: 'Microsoft CRM',
                level: 'INFO',
                message: 'Successfully retrieved 24 records',
            },
            {
                stamp: '4 Jul 2021, 00:45:00',
                topic: 'TVG',
                level: 'INFO',
                message: 'Queue: Successfully queued 24 videos',
            },
            {
                stamp: '4 Jul 2021, 01:04:11',
                topic: 'TVG',
                level: 'INFO',
                message: 'RenderEngine: Successfully generated 24 videos',
            },
            {
                stamp: '4 Jul 2021, 01:04:13',
                topic: 'TVG',
                level: 'INFO',
                message: 'PostProcess: Called webhook: INFORM_CRM_VIDEO_URI',
            },
        ]
    );

    const columns = React.useMemo(
        () => [
            {
                Header: 'Stamp',
                accessor: 'stamp', // accessor is the "key" in the data
            },
            {
                Header: 'Topic',
                accessor: 'topic',
            },
            {
                Header: 'Level',
                accessor: 'level',
            },
            {
                Header: 'Message',
                accessor: 'message',
            },
        ], []
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({columns, data})

    return (
        <div className="view">
            <div className="filters">
                <DatePicker
                    locale="en"
                    selected={startDate}
                    onChange={date => setStartDate(date)}
                    showTimeSelect
                    dateFormat="dd MMMM yyyy HH:mm"
                />
                <Select
                    className="react-select"
                    options={filters}
                    onChange={(e) => setType(e)}
                    defaultValue={type}
                    isMulti
                />
            </div>
            <h1 className="heading heading--lg">Logging</h1>
            <table className="table" {...getTableProps()}>
                <thead>
                {headerGroups.map(headerGroup => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map(column => (
                            <th
                                {...column.getHeaderProps()}
                            >
                                {column.render('Header')}
                            </th>
                        ))}
                    </tr>
                ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                {rows.map(row => {
                    prepareRow(row)
                    return (
                        <tr {...row.getRowProps()}>
                            {row.cells.map(cell => {
                                return (
                                    <td
                                        {...cell.getCellProps()}
                                    >
                                        {cell.render('Cell')}
                                    </td>
                                )
                            })}
                        </tr>
                    )
                })}
                </tbody>
            </table>
        </div>
    )
};

export default LoggingView;
